import { querySelectorAll } from '../helpers'

function getSelectedOption(select: HTMLSelectElement) {
  const selectedOption = querySelectorAll<HTMLOptionElement>(':checked', select)

  if (selectedOption.length) {
    return selectedOption[0]
  }
  return null
}

function updateLabel(select: HTMLSelectElement, label: HTMLElement) {
  const selectedOption = getSelectedOption(select)
  label.innerText = selectedOption ? selectedOption.text : ''
}

export function styleSelectElements() {
  querySelectorAll<HTMLSelectElement>('select').forEach(select => {
    const wrapper = document.createElement('div')
    wrapper.className = 'select-wrapper'
    if (select.parentNode) {
      select.parentNode.insertBefore(wrapper, select)
      wrapper.appendChild(select)
      const label = document.createElement('span')
      label.className = 'select-wrapper_label'
      wrapper.appendChild(label)

      updateLabel(select, label)

      select.addEventListener('change', () => {
        updateLabel(select, label)
      })
    }
  })
}
